import { get } from './index';
import algoliaDefaultSettings from '../algoliaDefaultSettings.json';
var state = {
  client: null,
  indexes: {}
};
var Algolia = {
  getClient: getClient,
  getIndex: getIndex,
  getFullIndexName: getFullIndexName,
  getFiltersFromCheckboxes: getFiltersFromCheckboxes,
  getFilters: getFilters
};
export default Algolia;
// declare var algoliaSettings: any;
function getClient() {
  if (state.client) {
    return Promise.resolve(state.client);
  }
  return import(/* webpackChunkName: "AlgoliaSearchLite" */'algoliasearch/lite').then(function (algoliasearch) {
    var applicationId = algoliaDefaultSettings.id;
    var apiKey = algoliaDefaultSettings.key;
    if (!process.env.STORYBOOK_MODE) {
      applicationId = get(window, 'algoliaSettings.id') || algoliaDefaultSettings.id;
      apiKey = get(window, 'algoliaSettings.key') || algoliaDefaultSettings.key;
    }
    if (!applicationId || !apiKey) {
      console.log('Algolia connection parameters were not provided');
    }
    state.client = algoliasearch.default(applicationId, apiKey);
    return state.client;
  });
}
function getIndex(indexNameSuffix) {
  var indexName = getFullIndexName(indexNameSuffix);
  if (state.indexes[indexName]) {
    return Promise.resolve(state.indexes[indexName]);
  }
  return Algolia.getClient().then(function (client) {
    state.indexes[indexName] = client.initIndex(indexName);
    return state.indexes[indexName];
  });
}
export function getFullIndexName(indexNameSuffix) {
  // this token will be replaced by Azure DevOps when deploying code to one of environments

  // const indexNameEnvVar = 'qa_vd_en';

  // // if the variable is set in process.env - use it, otherwise, fallback to string replaceable one
  // let indexNamePrefix = indexNameEnvVar ? indexNameEnvVar : 'dotqa104';

  // if (indexNamePrefix.startsWith('#')) {
  //   console.error(
  //     'The Algolia index name is neither defined as environment variable nor embedded via CI in js. Falling back to default: dotprod'
  //   );
  // }

  // // let indexNamePrefix = 'dotqa';

  // // but when running in styleguide or locally from Sitecore, the token won't be replaced
  // // so we need to replace it with 'dotsite' which is used for development
  // indexNamePrefix = indexNamePrefix.startsWith('#') ? 'dotprod' : indexNamePrefix;

  // const indexName = indexNamePrefix + indexNameSuffix;

  // debugger
  var wind = window;
  var prefix = wind.prefix;
  var fullTextSearchIndex = get(window, 'fullTextSearchIndex') || '';
  if (process.env.STORYBOOK_MODE) {
    fullTextSearchIndex = 'int_fulltext_leisure_en';
  }
  var result = prefix ? prefix + indexNameSuffix : indexNameSuffix;
  if (!result) {
    if (fullTextSearchIndex) {
      result = fullTextSearchIndex;
    }
  }
  return result;
}
function getFiltersFromCheckboxes(filtersObject, filterNameToOmit) {
  return Object.keys(filtersObject).reduce(function (filters, key) {
    if (key === filterNameToOmit) return filters;
    var filterPiece = [];
    // eslint-disable-next-line array-callback-return
    filtersObject[key].map(function (filterItem) {
      filterPiece.push("".concat(key, ":").concat(filterItem));
    });
    filters.push(filterPiece);
    return filters;
  }, []);
}
function getFilters() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filters = Object.values(data);
  return filters.reduce(function (filters, item) {
    if (item.targetItem) {
      var filter = item.targetItem;
      filters.push("".concat(filter.taxonomyType.value, ":").concat(filter.name));
    }
    if (item.targetItems) {
      var filtersArray = item.targetItems;
      // const filterPiece: string[] = [];
      filtersArray.forEach(function (filterItem) {
        filters.push("".concat(filterItem.taxonomyType.value, ":").concat(filterItem.name));
      });
      // filters.push(filterPiece);
    }
    return filters;
  }, []);
}